import { script } from "../../../../../../../../../theme/images";
import {StubbornToolboxProperties} from "../../../../../../../../business/StubbornToolboxMapping";

export const toolbox: StubbornToolboxProperties = {
  name: 'codeArea',
  label: 'Code Area',
  category: 'Inputs',
  image: script
};
